import PastPost from "./PastPost";

export const routes = [
    {
        path: "/past-posts/:userId/:generation",
        component: PastPost,
        exact: true,
        showNav: true
    }
]